import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  components: {
    MuiTableCell: {
      defaultProps: { align: 'center' },
      styleOverrides: { root: { whiteSpace: 'nowrap' } },
    },
  },
})
